import { DataBean } from "../DataBean";

export class AccountingData extends DataBean {



    public async updateAccountingData(year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateAccountingData_Number_Number", [year,month]);
    }
}